import { z } from 'zod';
import { estimatedDecodedByteLength, normalizeUploadBase64, } from '../purchase-order/upload-file-input.js';
import { disallowedFileTypeMessage } from '../zod-helpers/disallowed-file-type-message.js';
import { fileTooLargeMessage } from '../zod-helpers/file-too-large-message.js';
import { optionalClientGeneratedUuidString } from '../zod-helpers/optional-client-generated-uuid-string.js';
import { TRANSFER_ORDER_FILE_CONSTRAINTS } from './file-constants.js';
const { maxBytes, allowedMimeTypes } = TRANSFER_ORDER_FILE_CONSTRAINTS;
const tooLargeMessage = fileTooLargeMessage(maxBytes);
export const uploadTransferOrderFileInputSchema = z
    .object({
    fileName: z
        .string()
        .trim()
        .min(1, 'File name is required.')
        .max(255)
        // Node's response.writeHead throws for code points above U+00FF, so reject them at upload.
        .regex(/^[\x20-\x7E\x80-\xFF]+$/, 'File name contains unsupported characters.'),
    mimeType: z.enum(allowedMimeTypes, disallowedFileTypeMessage(allowedMimeTypes)),
    /** Caller-generated UUID used as a deduplication key so retries return the existing file. */
    clientUploadId: optionalClientGeneratedUuidString('Invalid upload id.'),
    contentBase64: z
        .string()
        .min(1, 'File content is required.')
        .max(Math.ceil((maxBytes * 4) / 3) + 100, tooLargeMessage),
})
    .superRefine((value, context) => {
    const normalized = normalizeUploadBase64(value.contentBase64);
    if (!normalized) {
        context.addIssue({
            code: 'custom',
            message: 'File content is invalid.',
            path: ['contentBase64'],
        });
        return;
    }
    const byteLength = estimatedDecodedByteLength(normalized);
    if (byteLength === 0) {
        context.addIssue({ code: 'custom', message: 'File is empty.', path: ['contentBase64'] });
        return;
    }
    if (byteLength > maxBytes) {
        context.addIssue({
            code: 'custom',
            message: tooLargeMessage,
            path: ['contentBase64'],
        });
    }
});
//# sourceMappingURL=upload-file-input.js.map